import React from "react";
import "./Header.css"

const Header = () => (
    <div id="name">
       AVOXI Skills Test 
    </div>
);
export default Header;



// WEBPACK FOOTER //
// ./src/components/Header/Header.js